import * as echarts from 'echarts';

// Utility function to create legend configuration
export const createLegendConfig = (
  isDark: boolean,
  axisColor: string,
): echarts.LegendComponentOption => {
  return {
    type: 'scroll',
    top: 0,
    padding: [4, 8],
    itemGap: 12, // Increased gap for multi-line legend items
    width: '100%',
    selectedMode: true,
    orient: 'horizontal',
    pageButtonPosition: 'end',
    pageButtonGap: 8,
    pageIconColor: isDark ? '#E5E7EB' : '#374151',
    pageIconInactiveColor: isDark ? '#6B7280' : '#9CA3AF',
    pageTextStyle: {
      color: axisColor,
      fontSize: 9,
    },
    textStyle: {
      color: axisColor,
      fontSize: 9,
      fontWeight: 400,
    },
    itemStyle: {
      borderWidth: 0,
    },
    itemWidth: 12,
    itemHeight: 24, // Increased height to accommodate multi-line text
    icon: 'roundRect',
    formatter: (name: string) => {
      // Add line breaks for long model names to make them fully readable
      if (name.length > 25) {
        // Split at natural break points like " | " or after ~20 characters
        if (name.includes(' | ')) {
          return name.replace(' | ', '\n');
        }
        // For other long names, break at spaces near the middle
        const words = name.split(' ');
        if (words.length > 1) {
          const midPoint = Math.floor(words.length / 2);
          return words.slice(0, midPoint).join(' ') + '\n' + words.slice(midPoint).join(' ');
        }
        // If no spaces, break at character 20
        return name.substring(0, 20) + '\n' + name.substring(20);
      }
      return name;
    },
  };
};
